import React from 'react'
import { ButtonGroupProps } from './props'
import { StyledButtonGroup } from './styles'

const ButtonGroup = ({ children, rounded, variant }: ButtonGroupProps) => {
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child))
            React.cloneElement(child, {
                variant,
                rounded,
            })

        return child
    })

    return <StyledButtonGroup>{childrenWithProps}</StyledButtonGroup>
}

export default ButtonGroup

export { StyledButtonGroup }
